import { render, staticRenderFns } from "./BuyClicksList.vue?vue&type=template&id=dde7999a&scoped=true"
import script from "./BuyClicksList.vue?vue&type=script&lang=js"
export * from "./BuyClicksList.vue?vue&type=script&lang=js"
import style0 from "./BuyClicksList.vue?vue&type=style&index=0&id=dde7999a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde7999a",
  null
  
)

export default component.exports